import { render } from "./infoCard.vue?vue&type=template&id=54620c45&scoped=true"
import script from "./infoCard.vue?vue&type=script&lang=js"
export * from "./infoCard.vue?vue&type=script&lang=js"

import "./infoCard.vue?vue&type=style&index=0&id=54620c45&lang=css&scoped=true"

import exportComponent from "C:\\Users\\ulrik\\vueProjects\\ezida\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54620c45"]])

export default __exports__